import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import EstornarItemAdesaoInput from '@/core/apiclient/item-adesao/estorno/models/EstornarItemAdesaoInput'

export default {
	async [actionTypes.ADESAO.ESTORNO.ESTORNAR.ESTORNAR_ITEM]({ state }, { cancelarDocProcessoDigital, idAdesao }) {
		let estornarItemAdesaoInput = new EstornarItemAdesaoInput(
			getIdsItensAdesao(state),
			state.form.justificativa,
			state.form.quantidadeEstorno,
			idAdesao,
			cancelarDocProcessoDigital,
		)
		await api.itemAdesaoEstorno.estornar(estornarItemAdesaoInput)
	},
}

function getIdsItensAdesao(state) {
	return state.form.itensAdesao.map((item) => item.idItemAdesao)
}
